import React, { Component } from "react";

class Email extends Component {
    render() {
        return (
            <a href={"mailto:" + this.props.name + "@" + this.props.domain}>
                {this.props.name + "@" + this.props.domain}
            </a>
        );
    }
}

export default Email;



// WEBPACK FOOTER //
// ./src/components/Email.jsx